import { type DELIVERY_PROVIDER_STATUS } from '@koala/sdk';

export interface IProgressBarStatus {
  position: number;
  status: DELIVERY_PROVIDER_STATUS;
  headerCmsKey: string;
  subheaderCmsKey: string;
  dataObj?: object | null;
  state?: PROGRESS_BAR_STATES;
}
export enum PROGRESS_BAR_STATES {
  CURRENT_IN_PROGRESS = 'in-progress',
  FINISHED = 'finished',
}
